import { render, staticRenderFns } from "./InvoicesDataTable.vue?vue&type=template&id=32ba286a&scoped=true&"
import script from "./InvoicesDataTable.vue?vue&type=script&lang=js&"
export * from "./InvoicesDataTable.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesDataTable.vue?vue&type=style&index=0&id=32ba286a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba286a",
  null
  
)

export default component.exports